import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./rules-filter.module.scss";
import { VelavuRuleCategory } from "velavu-js-api";
import VelavuSegmentedControls from "../../elements/velavu-segmented-controls";
import { mapRuleCategory } from "../../helper/language-helper";

export interface RulesFilterProps {
	category: VelavuRuleCategory | null;
	onChangeCategory: (category: VelavuRuleCategory | null) => void;
}

const CATEGORY_ARRAY: readonly (VelavuRuleCategory | null)[] = [
	VelavuRuleCategory.User,
	VelavuRuleCategory.System,
	VelavuRuleCategory.Managed,
	null,
];

export default function RulesFilter(props: RulesFilterProps) {
	const { t } = useTranslation();

	const mapNullableRuleCategory = useCallback(
		(category: VelavuRuleCategory | null): string => {
			if (category === null) {
				return t("rules.filter.all");
			}
			return mapRuleCategory(category, t);
		},
		[t],
	);
	const categoryIndex = useMemo(() => {
		return CATEGORY_ARRAY.indexOf(props.category);
	}, [props.category]);

	const onChangeCategory = props.onChangeCategory;
	const onSelectCategoryIndex = useCallback(
		(idx: number) => {
			const category = CATEGORY_ARRAY[idx];
			onChangeCategory(category);
		},
		[onChangeCategory],
	);

	const categoryLabels = useMemo(() => {
		return CATEGORY_ARRAY.map(mapNullableRuleCategory);
	}, [mapNullableRuleCategory]);

	return (
		<div className={styles.container}>
			<VelavuSegmentedControls
				selectedIndex={categoryIndex}
				onSelectIndex={onSelectCategoryIndex}
				labels={categoryLabels}
			/>
		</div>
	);
}
